export const GA4_EVENTS = {
  LEAD_LANDING_VIEW: 'lead_landing_view',
  FORM_STEP_VIEW: 'form_step_view',
  FORM_VISIT_NO_ACTION: 'form_visit_no_action',
  FORM_START: 'form_start',
  FORM_VALIDATION_ERROR: 'form_validation_error',
  SCROLL_DEPTH: 'scroll_depth',
  ENGAGEMENT_TIME_THRESHOLD: 'engagement_time_threshold',
} as const;

/** scroll_depth thresholds (% of page scrolled) — each fires once per pathname per session. */
export const SCROLL_DEPTH_THRESHOLDS = [25, 50, 75, 90] as const;

/**
 * engagement_time_threshold thresholds (sec of active time) — each fires once per session.
 * MUST stay sorted ascending: the tracker schedules the next *future* threshold and fires all
 * already-reached ones in order, both of which assume ascending values.
 */
export const ENGAGEMENT_TIME_THRESHOLDS = [10, 30, 60] as const;

export const FORM_STEP_NAMES: Record<number, string> = {
  0: 'landing',
  1: 'prelead',
  2: 'contact_details',
  3: 'confirmation',
  4: 'pending',
};
